// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body>main#app{min-height:100vh;display:flex;flex-direction:column}footer{margin-top:auto}#meta-pixel{height:1;width:1;display:none}`, "",{"version":3,"sources":["webpack://./themes/38degrees/styles.scss"],"names":[],"mappings":"AAGA,cACE,gBAAA,CACA,YAAA,CACA,qBAAA,CAGF,OACE,eAAA,CAIF,YACE,QAAA,CACA,OAAA,CACA,YAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
